/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MiniGameAddonSelection } from './MiniGameAddonSelection';
import {
    MiniGameAddonSelectionFromJSON,
    MiniGameAddonSelectionFromJSONTyped,
    MiniGameAddonSelectionToJSON,
} from './MiniGameAddonSelection';

/**
 * 
 * @export
 * @interface AddonSelection
 */
export interface AddonSelection {
    /**
     * 
     * @type {MiniGameAddonSelection}
     * @memberof AddonSelection
     */
    miniGameAddon?: MiniGameAddonSelection;
    /**
     * 
     * @type {string}
     * @memberof AddonSelection
     */
    extraDrawAddon?: string;
    /**
     * 
     * @type {string}
     * @memberof AddonSelection
     */
    multiplierAddon?: string;
}

/**
 * Check if a given object implements the AddonSelection interface.
 */
export function instanceOfAddonSelection(value: object): value is AddonSelection {
    return true;
}

export function AddonSelectionFromJSON(json: any): AddonSelection {
    return AddonSelectionFromJSONTyped(json, false);
}

export function AddonSelectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddonSelection {
    if (json == null) {
        return json;
    }
    return {
        
        'miniGameAddon': json['miniGameAddon'] == null ? undefined : MiniGameAddonSelectionFromJSON(json['miniGameAddon']),
        'extraDrawAddon': json['extraDrawAddon'] == null ? undefined : json['extraDrawAddon'],
        'multiplierAddon': json['multiplierAddon'] == null ? undefined : json['multiplierAddon'],
    };
}

export function AddonSelectionToJSON(value?: AddonSelection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'miniGameAddon': MiniGameAddonSelectionToJSON(value['miniGameAddon']),
        'extraDrawAddon': value['extraDrawAddon'],
        'multiplierAddon': value['multiplierAddon'],
    };
}

